import { Link } from 'react-router-dom';

interface SubScoreCardProps {
  to: string;
  label: string;
  score: number;
}

function scoreTone(score: number): 'good' | 'fair' | 'low' {
  if (score >= 75) return 'good';
  if (score >= 55) return 'fair';
  return 'low';
}

export function SubScoreCard({ to, label, score }: SubScoreCardProps) {
  return (
    <Link to={to} className={`sub-score-card sub-score-card--${scoreTone(score)}`}>
      <span className="sub-score-card__value">{Math.round(score)}</span>
      <span className="sub-score-card__label">{label}</span>
    </Link>
  );
}
